<template lang="pug">
#visualizar-carbono-imovel
    BaseHeader(
            titulo='MT-5100805-97F46D6DDC8448C394CF0882920D97B0',
            :breadcrumb='breadcrumb',
            :exibeBotao="false"
        )
        template(slot='direita')
            el-dropdown
                BaseButton( type="primary" )
                    | Ações
                    i( class="el-icon-arrow-down el-icon--right" )

                el-dropdown-menu( slot="dropdown" )
                    el-dropdown-item( icon="el-icon-plus" ) Action 1
                    el-dropdown-item( icon="el-icon-plus" ) Action 2
                    el-dropdown-item( icon="el-icon-plus" ) Action 3
                    el-dropdown-item( icon="el-icon-plus" ) Action 4
                    el-dropdown-item( icon="el-icon-plus" ) Action 5
    .view-container
        BlocoVisaoGeral

        .carbono-imovel
            h3 Dados sociambientais
            .carbono-imovel--alinhamento
                BlocoSituacaoTerritorio(
                    titulo='Embargos e Desmatamento',
                    subTitulo='Não conformidades:',
                    valor='00',
                )
                BlocoSituacaoTerritorio(
                    titulo='Áreas Protegidas',
                    subTitulo='Não conformidades:',
                    valor='00',
                )
                BlocoSituacaoTerritorio(
                    titulo='Social',
                    subTitulo='Não conformidades:',
                    valor='00',
                )
                BlocoSituacaoTerritorio(
                    titulo='Pessoas',
                    subTitulo='Não conformidades:',
                    valor='00',
                )

        BlocoPSAeAtivosAmbientais
        BlocoAnaliseConformidadeCodigoFlorestal
        
        .mapa
            Mapa(
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaVisualizarInteligenciaCarbono"',
                ref='mapa'
                )

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoVisaoGeral from '@/components/inteligenciaCarbono/BlocoVisaoGeral';
import BlocoSituacaoTerritorio from '@/components/monitoramento/BlocoSituacaoTerritorio';
import BlocoPSAeAtivosAmbientais from '@/components/inteligenciaCarbono/BlocoPSAeAtivosAmbientais';
import BlocoAnaliseConformidadeCodigoFlorestal from '@/components/inteligenciaCarbono/BlocoAnaliseConformidadeCodigoFlorestal';
import Mapa from '@/components/MapaLeaflet.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'VisualizarCarbonoImovel',
    components: {
        BaseHeader,
        BlocoVisaoGeral,
        BlocoSituacaoTerritorio,
        BlocoPSAeAtivosAmbientais,
        BlocoAnaliseConformidadeCodigoFlorestal,
        Mapa,
        BaseButton
    },
    data() {
        return {
            breadcrumb: [
                { nome: 'Visão geral', rota: 'CarbonoImovel' },
                { nome: 'Visão geral', rota: 'InteligenciaCarbono' }
            ],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                }
            }
        };
    },
    methods: {
    }
};

</script>

<style lang="scss" scoped>
#visualizar-carbono-imovel {
    .carbono-imovel h3 {
        font-weight: 600;
        margin-top: 30px;
        margin-bottom: 12px;
        color: #3b3b3b;
    }
    .carbono-imovel--alinhamento {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .bloco-situacao-territorio {
        width: 24.25%;
    }
    .mapa {
        height: 480px;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 20px;
    }
}

</style>
